function injectStyle (ssrContext) {
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-aa06f2d2\",\"scoped\":false,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./PetitionForm.vue")
  require("!!../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-aa06f2d2\",\"scoped\":true,\"hasInlineConfig\":false}!../../node_modules/vue-loader/lib/selector?type=styles&index=1!../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./PetitionForm.vue")
}
var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./PetitionForm.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-aa06f2d2\",\"hasScoped\":true}!../../node_modules/vue-loader/lib/selector?type=template&index=0!../../node_modules/string-replace-webpack-plugin/loader.js?id=mj8nq3d7c3!../../node_modules/string-replace-webpack-plugin/loader.js?id=pgjqzajuokf!./PetitionForm.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-aa06f2d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/PetitionForm.vue
// module id = 242
// module chunks = 0